import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { translate } from 'react-i18next';
import { firebaseConnect, isEmpty, isLoaded } from 'react-redux-firebase';
import { AppView, ListSection, Input } from 'medua-components';

/* eslint-disable */
@firebaseConnect()
@translate(['account', 'actions'])
export default class AccountEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      edited: false,
      toggle: '',

      user: {},
    };
  }

  componentWillMount() {
    if (isEmpty(this.state.user) && isLoaded(this.props.user) && this.props.user.info) {
      this.setState({ user: this.props.user.info });
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.user.info && (newProps.user.info !== this.props.user.info) && isEmpty(this.state.user)) {
      this.setState({ user: newProps.user.info });
    }
  }

  render() {
    const { user: { info } } = this.props
    const { givenName, familyName } = this.state.user
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:edit.title') }
        error={ this.state.error }
        headerActionRight={[
          { key: 1, icon: 'save', action: this.handleSave, visible: this.state.edited }
        ]}>
        <ListSection margin padding
          accent={{ highlight: 'turquoise' }}>
          <Input
            disabled
            meta={ this.props.t('account:terms.email') }
            value={ this.props.auth.email }
            button={{ text: this.props.t('actions:text.change'), action: (e) => this.setState({ name: e.target.value }) }} />
        </ListSection>
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/edit/index.jsx